export default "__VITE_ASSET__hsZi2MfZ__"